<template>
    <v-container fluid>
        <v-layout row wrap mb-2>
            <v-flex xs10 offset-xs1 mb-2>
                <span class="green--text">Torneos</span>
                <span class="ml-3 mr-3">></span>
                <span>Nombre del Torneo</span>
                <span class="ml-3 mr-3">></span>
                <span>Estado de Cuenta</span>
            </v-flex>
            <v-flex xs10 offset-xs1>
                <h4 class="green--text headline">Estado de cuenta</h4>
            </v-flex>
            <v-flex xs10 offset-xs1>
                <v-text-field
                    label="Buscar equipo"
                    box
                    class="green--text"
                    append-icon="search"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs10 offset-xs1>
                <v-data-table
                :rows-per-page-items="[25,50,100]"
                    :headers="headers"
                    :items="teams"
                    class="elevation-1"
                    light
                    hide-actions
                    no-results-text=""
                    >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-right">{{ props.item.id }}</td>
                        <td class="text-xs-right">{{ props.item.team }}</td>
                        <td class="text-xs-right">
                            {{ props.item.id }}
                            <v-btn small icon flat color="grey" @click="showPaymentModal = true">
                                <v-icon>create</v-icon>
                            </v-btn>
                        </td>
                        <td class="text-xs-right">
                            {{ props.item.paidOut }}
                            <v-btn small icon flat color="grey">
                                <v-icon>add_circle_outline</v-icon>
                            </v-btn>
                        </td>
                        <td class="text-xs-right">{{ props.item.balance }}</td>
                    </template>
                    <template slot="footer">
                        <td></td>
                        <td class="text-xs-right pr-4">
                            <strong>TOTALES</strong>
                        </td>
                        <td class="text-xs-right pr-4 green--text">
                            $0.00
                        </td>
                        <td class="text-xs-right pr-4 green--text">
                            $0.00
                        </td>
                        <td class="text-xs-right pr-4 green--text">
                            $0.00
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <payment-modal :dialog="showPaymentModal" :team="'PITZ'" @response="doPayment($event)"></payment-modal>
    </v-container>
</template>

<script>
    import PaymentModal from './PaymentModal'

    export default {
        name:'AccountStatus',
        components: {
            PaymentModal
        },
        data() {
            return {
                showPaymentModal: false,
                headers: [
                    { text: '#', value: 'id' },
                    { text: 'Equipo', value: 'team' },
                    { text: 'Total a pagar', value: 'totalToPay' },
                    { text: 'Pagado', value: 'paidOut' },
                    { text: 'Saldo al corte', value: 'balance' }
                ],
                teams: [
                    {
                        id: 1,
                        team: 'PITZ',
                        totalToPay: 0,
                        paidOut: 0,
                        balance: 0
                    },
                    {
                        id: 1,
                        team: 'Amplemind',
                        totalToPay: 0,
                        paidOut: 0,
                        balance: 0
                    },
                ]
            }
        },
        methods: {
            doPayment(data) {
                if(data.response)
                    console.log(data)

                this.showPaymentModal = false
            }
        }
    }
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/account_status/AccountStatus.vue